import React from "react";

import { Decimal, StabilityDeposit, StabilityDepositChange } from "@liquity/lib-base";

import { COIN, GT } from "../../strings";
import { ActionDescription, Amount } from "../ActionDescription";
import { CollateralLexicon } from "src/lexicon"

type StabilityActionDescriptionProps = {
  originalDeposit: StabilityDeposit;
  change: StabilityDepositChange<Decimal>;
  lexicon: CollateralLexicon | undefined;
};

export const StabilityActionDescription: React.FC<StabilityActionDescriptionProps> = ({
  originalDeposit,
  change,
  lexicon
}) => {
  const collateralGain = originalDeposit.collateralGain.nonZero?.prettify(4).concat(` ${lexicon?.term ?? ''}`);
  // const lqtyReward = originalDeposit.lqtyReward.nonZero?.prettify().concat(" ", GT);

  return (
    <ActionDescription>
      {change.depositSLSD ? (
        <>
          You are depositing{" "}
          <Amount>
            {change.depositSLSD.prettify()} {COIN}
          </Amount>{" "}
          in the Stability Pool
        </>
      ) : (
        <>
          You are withdrawing{" "}
          <Amount>
            {change.withdrawSLSD.prettify()} {COIN}
          </Amount>{" "}
          to your wallet
        </>
      )}
      {(collateralGain) && (
        <>
          {" "}
          and claiming at least{" "}
          {collateralGain && (
            <Amount>{collateralGain}</Amount>
          )}
        </>
      )}
      .
    </ActionDescription>
  );
};
